module.exports = __webpack_public_path__ + "img/yakiton_higashinakano.f936d241.jpg";